module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC8SURBVHgBjZINEcIwDIVTDgGVEAlImAQk4AAkgILhYBKQUFBQHHQOwEFIaMuVLtv63WU/L31JuwWAISILCqwjh6NIn7R9Tu4kOWMMNKX/NuJLl4ShMnWK6cXh8wJbJIIYkn4gHSyruyopBbzmyp6tnJHvWB0PQeedHzYcI4eFNp4/ozFGqlwajY+/t/SBHK2D5VYzCMvceXfjRKU4Jb6lm2Y+zpjO2mIZuYHiVGicljrJeN0Kc+C4pn+s8gHq31+42dZVLQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tut.png
// module id = 9420
// module chunks = 0